import React, { useState } from 'react';
import { useToast } from '../hooks/use-toast';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HeroSection = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    phone: '',
    email: '',
    city: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate age
    const age = parseInt(formData.age);
    if (age < 13 || age > 19) {
      toast({
        title: "Invalid Age",
        description: "Sorry, you must be between 13-19 years old to apply.",
        variant: "destructive",
      });
      return;
    }
    
    setSubmitting(true);
    
    try {
      // Submit to backend
      const response = await axios.post(`${API}/enquiry/submit`, {
        ...formData,
        age: parseInt(formData.age)
      });
      
      // Navigate to confirmation page with enquiry data
      navigate('/registration-confirm', {
        state: { enquiry: response.data }
      });
      
    } catch (error) {
      console.error('Error submitting form:', error);
      toast({
        title: "Submission Failed",
        description: error.response?.data?.detail || "Please try again later.",
        variant: "destructive",
      });
      setSubmitting(false);
    }
  };

  return (
    <section className="hero-fullwidth">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-0">
        {/* Left Banner */}
        <div className="md:col-span-8 col-span-12">
          <img 
            src="/slider.jpg" 
            className="w-full h-full object-contain md:object-cover min-h-[300px] md:min-h-[600px] bg-black" 
            alt="Alee Club Banner"
          />
        </div>

        {/* Right Form */}
        <div className="md:col-span-4 col-span-12 flex items-center justify-center p-6 bg-white">
          <div className="w-full max-w-[380px] p-6 shadow-xl rounded-xl bg-white border border-gray-100">
            <h4 className="font-bold text-center mb-4 text-lg md:text-xl leading-tight">
              Become The Next Superstar<br />
              <span className="text-red-600">with Alee Club</span>
            </h4>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                className="w-full p-3 mb-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                placeholder="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                pattern="[A-Za-z0-9_ ]{1,150}"
                title="Accept Only Name and Space"
                required
              />

              <input
                type="number"
                className="w-full p-3 mb-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                placeholder="Your Age (13-19)"
                name="age"
                value={formData.age}
                onChange={handleChange}
                min="13"
                max="19"
                title="Age must be between 13 and 19 years"
                required
              />

              <input
                type="tel"
                className="w-full p-3 mb-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                placeholder="+91 9999999999"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                pattern="[7896][0-9]{9}"
                minLength="10"
                maxLength="10"
                required
              />

              <input
                type="email"
                className="w-full p-3 mb-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                className="w-full p-3 mb-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                required
              />

              <button
                type="submit"
                disabled={submitting}
                className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {submitting ? 'Submitting...' : 'Apply Now'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;